import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sc-twoone-twotwo',
  templateUrl: './sc-twoone-twotwo.component.html',
  styleUrls: ['./sc-twoone-twotwo.component.scss']
})
export class ScTwooneTwotwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
